import { cn } from '@nexelem/utils';
import { DayButtonProps } from 'react-day-picker';

export const CalendarButton = ({
  className,
  children,
  day: _removeDay,
  modifiers: _removeModifiers,
  ...props
}: React.ComponentProps<'button'> & Partial<DayButtonProps>) => (
  <button
    className={cn(
      'h-full w-full cursor-pointer border-0 bg-transparent text-s16 text-text-action [&:not(:disabled):hover_.active-button]:bg-surface-hover-lighter',
      className,
    )}
    {...props}
  >
    <div className="highlight-button box-border flex items-center justify-center">
      <div className="active-button box-border flex h-9 w-9 max-w-9 min-w-9 items-center justify-center rounded-full">
        {children}
      </div>
    </div>
  </button>
);
